"use client"

import { useEffect, useState, type CSSProperties } from "react"

const KEYBOARD_THRESHOLD = 150
/** Зазор сверху, чтобы поднятая шторка не упиралась в край видимой области */
const TOP_GAP = 16

/**
 * Стиль нижней шторки (vaul `Drawer` c `repositionInputs={false}`), при котором она не уходит
 * под экранную клавиатуру: поднимается к нижнему краю видимой области (visualViewport)
 * и ужимается по её высоте. Без этого на iOS шторка остаётся прижатой к низу layout viewport,
 * а `lib/viewport.ts` гасит прокрутку visualViewport — поле ввода оказывается под клавиатурой.
 * Тот же приём, что у полноэкранного листа копилота (copilot-fullscreen-sheet.tsx).
 */
export function useDrawerKeyboardStyle(active: boolean): CSSProperties | undefined {
  const [style, setStyle] = useState<CSSProperties>()

  useEffect(() => {
    const vv = window.visualViewport
    if (!active || !vv) return
    const update = () => {
      if (window.innerHeight - vv.height <= KEYBOARD_THRESHOLD) {
        setStyle(undefined)
        return
      }
      setStyle({
        bottom: Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop)),
        maxHeight: Math.round(vv.height) - TOP_GAP,
      })
    }
    update()
    vv.addEventListener("resize", update)
    vv.addEventListener("scroll", update)
    return () => {
      vv.removeEventListener("resize", update)
      vv.removeEventListener("scroll", update)
      setStyle(undefined)
    }
  }, [active])

  return style
}
